export default "__VITE_ASSET__cYgFGpTF__"